import { Component } from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {GetAppDialogComponent} from '@shared/modules/shared-dialogs/dialogs/get-app-dialog/get-app-dialog.component';
import {NewsRegisterReporterDialogComponent} from '@shared/modules/shared-news/dialogs/news-register-reporter-dialog/news-register-reporter-dialog.component';
import {UserService} from '@core/services/user.service';
import {NewsRegisterReporterNameComponent} from '@shared/modules/shared-news/dialogs/news-register-reporter-name-dialog/news-register-reporter-name.component';

@Component({
  selector: 'app-news-reporter-dialog',
  templateUrl: './news-reporter-dialog.component.html',
  styleUrls: [
    '../news-dialogs-styles.scss',
    './news-reporter-dialog.component.scss'
  ]
})
export class NewsReporterDialogComponent {

  public static getDialogSize(): MatDialogConfig {
    return {
      maxWidth: '600px', width: '80vw', maxHeight: '75%', autoFocus: false
    };
  }

  constructor( public dialogRef: MatDialogRef<NewsReporterDialogComponent>,
               private userService: UserService,
               private dialog: MatDialog ) { }

  public onNotifications(): void {
    this.dialogRef.close();
    this.dialog.open(GetAppDialogComponent, GetAppDialogComponent.getDialogSize());
  }

  public onRegister(): void {
    this.dialogRef.close();
    if (this.userService.currentUser != null && this.userService.currentUser.firstname && this.userService.currentUser.lastname) {
      const config = NewsRegisterReporterDialogComponent.getDialogSize();
      config.data = {
        firstName: this.userService.currentUser.firstname,
        lastName: this.userService.currentUser.lastname
      };
      this.dialog.open(NewsRegisterReporterDialogComponent, config);
    } else {
      this.dialog.open(NewsRegisterReporterNameComponent, NewsRegisterReporterNameComponent.getDialogSize());
    }
  }

}
